import { connect } from 'react-redux'

import AddVehicle from './AddVehicle'

import { getFromSettings } from 'src/utils/helpers'
import { addVehicle } from '../actions'

const mapDispatchToProps = {
  addVehicle,
}

const mapStateToProps = state => {
  return {
    document: state.changePolicy.document,
    submitting: state.changePolicyReducer.submitting,
    successful: state.changePolicyReducer.successful,
    countryIsoCode: getFromSettings(state, 'countryIsoCode'),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddVehicle)
